import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/observable/from';
import { catchError } from 'rxjs/operators';
// tslint:disable-next-line:import-blacklist
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { productTypes, productBrands, productCategories, productSeries, getProductSearch, prontoBrands } from '../models/filter.model';

@Injectable()
export class SearchService {

  baseUrl = 'api/product';

  searchValue: string = "";
  brand: string = "";
  type: string = "";
  category: string = "";
  series: string = "";

  private searchValueSubject = new BehaviorSubject<string>(this.searchValue);
  private brandValueSubject = new BehaviorSubject<string>(this.brand);
  private typeValueSubject = new BehaviorSubject<string>(this.type);
  private categoryValueSubject = new BehaviorSubject<string>(this.category);
  private seriesValueSubject = new BehaviorSubject<string>(this.series);

  currentWatch = this.searchValueSubject.asObservable();
  currentBrandWatch = this.brandValueSubject.asObservable();
  currentTypeWatch = this.typeValueSubject.asObservable();
  currentCategoryWatch = this.categoryValueSubject.asObservable();
  currentSeriesWatch = this.seriesValueSubject.asObservable();


  constructor(private http: HttpClient,
    private authService: AuthService
  ) { }

  monitorSearchValueChange(searchValue: string, brand?: string, type?: string, category?: string, series?: string): void {
    this.searchValueSubject.next(searchValue);
    this.brandValueSubject.next(brand);
    this.typeValueSubject.next(type);
    this.categoryValueSubject.next(category);
    this.seriesValueSubject.next(series);
  }


  /**
   * search function
   * @param searchKeyword search keyword
   * @param brand the brand selected
   * @param type the type selected
   * @param category the category selected
   * @param series the series selected
   */
  retrieve(searchKeyword: string, brand?: string, type?: string, category?: string, series?: string, minPrice?: string, maxPrice?: string, minSOH?: string, excludeKits?: boolean): Observable<any> {
    brand = brand || '';
    type = type || '';
    category = category || '';
    series = series || '';
    minPrice = minPrice || '';
    maxPrice = maxPrice || '';
    minSOH = minSOH || '';
    excludeKits = excludeKits || false;

    return this.http.post(this.baseUrl + `/GetProductSearchResult`, {
      searchKeyword: encodeURIComponent(searchKeyword),
      brand,
      type,
      category:encodeURIComponent(category),
      series,
      minPrice,
      maxPrice,
      minSOH,
      excludeKits
    })
      .pipe(catchError(this.authService.handleError));
  }

  getBrandList(): Observable<prontoBrands[]> {
    return this.http.get<prontoBrands[]>(this.baseUrl + '/GetBrandList')
      .pipe(catchError(this.authService.handleError));
  }

  getProductTypes(brands: string): Observable<productTypes[]> {
    return this.http.get<productTypes[]>(this.baseUrl + '/GetProductTypes?brands=' + brands)
      .pipe(catchError(this.authService.handleError));
  }

  getProductBrands(types: string, categories: string, series: string): Observable<productBrands[]> {
    return this.http.get<productBrands[]>(this.baseUrl + '/GetProductBrands?types=' + types + '&categories=' + categories + '&series=' + series)
      .pipe(catchError(this.authService.handleError));
  }

  getProductCategories(types: string, brands: string): Observable<productCategories[]> {
    return this.http.get<productCategories[]>(this.baseUrl + '/GetProductCategories?types=' + types + '&brands=' + brands)
      .pipe(catchError(this.authService.handleError));
  }

  getProductSeries(types: string, categories: string, brands: string): Observable<productSeries[]> {
    return this.http.get<productSeries[]>(this.baseUrl + '/GetProductSeries?types=' + types + '&categories=' + categories + '&brands=' + brands)
      .pipe(catchError(this.authService.handleError));
  }

  getProductSearch(keyword: string, brands: string, types: string, categories: string, series: string, filterType: string): Observable<getProductSearch[]> {
    let out_type = 'N';
    let out_category = 'N';
    let out_series = 'N';
    let out_brand = 'N';
    switch (filterType) {
      case 'brand':
         out_brand = 'Y';
         break;
      case 'type':
         out_type = 'Y';
         break;
      case 'category':
         out_category = 'Y';
         break;
     case 'series':
         out_series = 'Y';
         break;
    }
    return this.http.get<getProductSearch[]>(this.baseUrl + '/GetProductSearch?in_keyword=' + keyword + '&in_brands=' + brands + '&in_types=' + types + '&in_categories=' + encodeURIComponent(categories)
       + '&in_series=' + series + '&out_type=' + out_type + '&out_category=' + out_category + '&out_series=' + out_series + '&out_brand=' + out_brand)
      .pipe(catchError(this.authService.handleError));
  }

  getSearchResultDownloadLink(searchKeyword: string, brand?: string, type?: string, category?: string, series?: string): Observable<any> {
    brand = brand || '';
    type = type || '';
    category = category || '';
    series = series || '';

    return this.http.get(this.baseUrl + `/getSearchResultDownloadLink?searchKeyword=${searchKeyword}&brand=${brand}&type=${type}&category=${category}&series=${series}`)
      .pipe(catchError(this.authService.handleError));
  }


}
